import React from "react";
import { useTheme } from "@/context/ThemeContext";
import { THEMES } from "@/lib/constants";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Palette } from "lucide-react";

export default function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          data-testid="theme-switcher-trigger"
          className="gap-2 rounded-full"
        >
          <Palette className="h-4 w-4" />
          <span className="hidden sm:inline">Theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-48">
        {THEMES.map((t) => (
          <DropdownMenuItem
            key={t.id}
            onClick={() => setTheme(t.id)}
            data-testid={`theme-switch-${t.id}`}
            className="flex items-center gap-3 cursor-pointer"
          >
            <span
              className="inline-block h-3 w-3 rounded-full ring-2 ring-background"
              style={{ background: t.dot }}
            />
            <span className="flex-1">{t.label}</span>
            {theme === t.id && <span className="text-xs text-muted-foreground">Active</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
